import React, { Component } from "react";
import { Input } from "antd";

class Grides extends Component {
    state = {};

    getSudoku = () => {
        const sudotype = {
            split_w: 3,
            split_h: 2,
            split_w_num: 6,
            gride_size: 40
        };
        let grids = this.props.values.map((d, i) => {
            const dom = d.map((d2, i2) => {
                // let isAnswer =
                let iscellRight = i2 === 5;
                let iscellBottom = i === 5; //是否是宫内的下侧格子
                let isTopcellTop = i === 0; //是否是最上的宫的宫内的上侧格子
                let isLeftcellLeft = i2 === 0; //是否是最左的宫内的左侧格子
                return (
                    <div
                        key={i + "" + i2}
                        style={{
                            // margin:1,
                            position: "relative",
                            float: "left",
                            fontSize: 14,
                            textAlign: "center",
                            width: sudotype.gride_size,
                            height: sudotype.gride_size,
                            lineHeight: sudotype.gride_size + "px",
                            boxSizing: "border-box",
                            border: "1px solid #666",
                            borderTopWidth: isTopcellTop ? "2px" : "0px",
                            borderBottomWidth: iscellBottom ? "2px" : "1px",
                            borderLeftWidth: isLeftcellLeft ? "2px" : "0px",
                            borderRightWidth: iscellRight ? "2px" : "1px"
                        }}
                        onClick={() => {
                        }}
                    >
                        <span
                            style={{
                                //非编辑状态显示此格子 编辑状态此格子透明显示上面的input
                                background: "#f5f5f5",
                                color: "#000",
                                height: "100%",
                                width: "100%",
                                position: "absolute",
                                top: 0,
                                left: 0
                            }}
                        >
                            { d2==0?"":d2}
                        </span>
                    </div>
                );
            });
            return dom;

            // let isRed = this.props.values.flat().match(/\^[1-9]/);
        });
        return grids;
    };
    render() {
        const sudotype = {
            split_w: 3,
            split_h: 2,
            split_w_num: 6,
            gride_size: 40
        };

        return (
            <div
                style={{
                    width: (sudotype.split_w_num + 1) * sudotype.gride_size - 1
                }}
            >
                <div style={{ overflow: "hidden" }}>{this.getSudoku()}</div>
            </div>
        );
    }
}

export default Grides;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ai_sudoku_ship/gridesView.js